<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = exTitle)"></div>
    <van-image fit="cover" class="actImg" :src="info.BannerMobile" />
    <div class="itemBox">
      <div class="itemAct">
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item01.png"
            style="width: 36px; height: 36px"
          />
        </div>
        <div class="itemContent">
          <div>全球照明产业数据资源库</div>
          <div>
            覆盖全球照明产业链30,000多家
            生产制造企业，140万专业买家，220万用户信息
          </div>
        </div>
      </div>
      <div class="itemAct">
        <div class="itemContent" style="padding-left: 4px">
          <div>照明研究院专家智库</div>
          <div>
            依托光亚20多年的展览与媒体积累，拥有设计施工、研究规划等八大类别共计
            300 多位顶级行业专家、 顾问、学者。
          </div>
        </div>
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item02.png"
            style="width: 37px; height: 29px"
          />
        </div>
      </div>
      <div class="itemAct">
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item03.png"
            style="width: 32px; height: 31px"
          />
        </div>
        <div class="itemContent">
          <div>中英文线上数字会展平台</div>
          <div>
            品牌在线云展示、新品在线发布、 数字化展厅、实时询盘获取、展商
            直播...
          </div>
        </div>
      </div>
      <div class="itemAct">
        <div class="itemContent" style="padding-left: 4px">
          <div>全方位国内外市场推广</div>
          <div>
            阿拉丁全媒体宣传推广、数字化 营销服务、EDM海外买家精准投 送、
            SNS海外标靶社媒渠道..
          </div>
        </div>
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item04.png"
            style="width: 33px; height: 31px"
          />
        </div>
      </div>
      <div class="itemAct">
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item05.png"
            style="width: 33px; height: 33px"
          />
        </div>
        <div class="itemContent">
          <div>LIGHTSTRADE 跨境贸易服务</div>
          <div>
            Lightstrade国际站专业客户服务系统辅助撮合转化贸易商机，为照明外销企业中的“实力派”提供全面的海外营销推广服务。
          </div>
        </div>
      </div>
      <div class="itemAct">
        <div
          class="itemContent"
          style="padding-left: 4px"
          v-if="info.IsOffline == 0"
        >
          <div>线上+线下融合发展</div>
          <div>
            阿拉丁网上照明展览会联合线下实体展，线上线下融合发展，双轮驱动，最大程度展示品牌风采
          </div>
        </div>
        <div class="itemContent" style="padding-left: 4px" v-else>
          <div>数字化国际会展</div>
          <div>
            线上搭建中英文数字会展，365天照明展示交互平台，全球照明产业信息互联、互补、互通。
          </div>
        </div>
        <div class="itemActImg">
          <img
            src="../../../static/images/index/item06.png"
            style="width: 38px; height: 25px"
          />
        </div>
      </div>
    </div>
    <!-- 主题展 -->
    <div class="topicBox">
      <div class="title">阿拉丁网上照明展览会系列主题展</div>
      <div class="table">
        <div style="font-size: 11px">
          <div style="background-color: #000; color: #fff">时间</div>
          <div style="background-color: #ee4d60; color: #fff">
            <div class="firstLine">
              <div>国内数字展会</div>
              <img
                src="../../../static/images/index/table01.png"
                style="width: 22px; height: 22px"
              />
            </div>
          </div>
          <div style="background-color: #ff9933; color: #fff">
            <div class="firstLine">
              <div>国外数字展会</div>
              <img
                src="../../../static/images/index/table02.png"
                style="width: 22px; height: 21px"
              />
            </div>
          </div>
        </div>
        <div v-for="(item, index) in bigList" :key="index">
          <div>{{ item.Months }}</div>
          <div v-if="item.listIn.length > 0">
            <div v-for="(pItem, pIndex) in item.listIn" :key="pIndex">
              <div
                @click="
                  toTabDetail(
                    pItem.SubjectExhibition.SEID,
                    pItem.SubjectExhibition.SETitle
                  )
                "
              >
                {{ pItem.SubjectExhibition.SETitle }}
              </div>
            </div>
          </div>
          <div v-else style="text-align: center; vertical-align: middle">
            ——
          </div>
          <div v-if="item.listOut.length > 0">
            <div v-for="(oItem, oIndex) in item.listOut" :key="oIndex">
              <div
                @click="
                  toTabDetail(
                    oItem.SubjectExhibition.SEID,
                    oItem.SubjectExhibition.SETitle
                  )
                "
              >
                {{ oItem.SubjectExhibition.SETitle }}
              </div>
            </div>
          </div>
          <div v-else style="text-align: center; vertical-align: middle">
            ——
          </div>
        </div>
      </div>
    </div>
    <!-- 活动板块 -->
    <div class="title">全年活动</div>
    <div class="swiper-box">
      <van-swipe
        class="sb_swiper"
        :autoplay="3000"
        :interval="interval"
        :duration="duration"
        :circular="true"
        :show-indicators="false"
        @change="bannerChange"
      >
        <van-swipe-item
          v-for="(item, index) in bannerList"
          :key="index"
          class="newsItem"
        >
          <img :src="item.Img" class="newsImg" />
          <div class="newsTitle">{{ item.Title }}</div>
          <div class="newsCotent">{{ item.Cotent }}</div>
        </van-swipe-item>
      </van-swipe>
      <!--重置小圆点的样式 -->
      <div class="dots">
        <div
          v-for="(item, index) in bannerList"
          :key="index"
          class="dot"
          :class="index == current ? 'active' : ''"
        ></div>
      </div>
    </div>
    <!-- 参展对象 -->
    <div class="joinBox">
      <div class="title">参展对象</div>
      <div class="joinCotent">{{ Content }}</div>
      <div class="joinBtn" @click="toDetailHandle">申请加入网上展厅</div>
    </div>
    <!-- 全方位国内外市场推广 -->
    <div class="title">全方位国内外市场推广</div>
    <div class="listBox">
      <div class="listItem" v-for="(item, index) in list" :key="index">
        <van-image fit="contain" :src="item.Img" />
        <div class="listContent">
          <div class="listTitle">{{ item.Title }}</div>
          <div class="listLine"></div>
          <div class="listSmallTitle">{{ item.subTitle }}</div>
        </div>
      </div>
    </div>
    <!-- 专业观众资源导入 -->
    <div class="importBox">
      <div class="title">专业观众资源导入</div>
      <div class="importTitle">
        覆盖照明产业链全球30000多家生产制造企业，140万专业买家、220万用户信息，具
        备大数据精准推广基础
      </div>
      <div class="swiper-box" style="height: 200px">
        <van-swipe
          :autoplay="3000"
          :interval="interval"
          :duration="duration"
          :circular="true"
          :show-indicators="false"
          @change="sourceChange"
        >
          <van-swipe-item
            v-for="(item, index) in sourceList"
            :key="index"
            class="newsItem"
          >
            <img :src="item" class="newsImg" />
          </van-swipe-item>
        </van-swipe>
        <!--重置小圆点的样式 -->
        <div class="dots" style="bottom: -55px">
          <div
            v-for="(item, index) in sourceList"
            :key="index"
            class="dot"
            :class="index == scurrent ? 'active' : ''"
          ></div>
        </div>
      </div>
    </div>
    <!-- 合作媒体资源导入 -->
    <div class="mediaBox">
      <div class="title">合作媒体资源导入</div>
      <div class="mediaTitle">多家合作媒体公司资源导入，给商家更大的曝光量</div>
      <div class="imgBox">
        <div
          class="advImg"
          v-for="(item, index) in mideaList"
          :key="index"
          @click="toMidea(item.URL)"
        >
          <van-image fit="contain" :src="item.Img" />
        </div>
      </div>
    </div>
    <!-- LIGHTSTRADE跨境贸易服务 -->
    <div class="serviceBox">
      <div class="title">LIGHTSTRADE跨境贸易服务</div>
      <div class="serviceContent">
        <img src="https://files.alighting.com/Cover/serviceImg.png" />
        <div class="serviceSub">
          Lightstrade.com（阿拉丁国际站）——
          专业照明国际(跨境)贸易服务平台，依托广州国际照明展26年实体展会优势，积累百万数量级海外买家资源；依托互联网数据技术及数据科学匹配推荐，充分发挥线上平台技术优势，在线高度还原跨境采购实景，深度链接匹配海外需求及国内供应链能力；专业客户服务系统辅助撮合转化贸易商机，为照明外销企业中的“实力派”提供全面的海外营销推广服务。
        </div>
      </div>
    </div>
    <!-- 往期回顾 -->
    <div class="title">往期回顾</div>
    <div class="listBox">
      <div
        class="listItem"
        v-for="(item, index) in hisList"
        :key="index"
        @click="toSpecialDetail(item.SpecialId)"
      >
        <van-image fit="contain" :src="item.Cover" />
        <div class="listContent">
          <div class="hisTitle">{{ item.Name }}</div>
        </div>
      </div>
    </div>
    <!-- 合作洽谈 -->
    <div class="chatBox">
      <div class="chatItem">
        <div class="chatTitle">合作洽谈</div>
        <div class="chatSubTitle">商业合作等请联系工作人员</div>
      </div>
      <div class="chatItem">
        <img src="../../../static/images/index/headImg.png" class="headImg" />
        <div class="name">尹女士</div>
        <div class="name">+86-13926499651</div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="operateBox">
      <div class="operateLeft" @click="toJoin">
        <img
          src="../../../static/images/index/yy.png"
          style="width: 15px; height: 16px; margin-right: 8px"
        />
        <div>参展报名</div>
      </div>
      <!-- <div class="operateRight" v-if="isTime == 0" @click="toSee">
        <img
          src="../../../static/images/index/apply.png"
          style="width: 16px; height: 17px; margin-right: 8px"
        />
        <div>观展预约</div>
      </div> -->
      <!-- <div
        class="operateRight"
        v-if="isTime == 1"
        @click="toSpecialDetail(info.SubjectExhibition.SEID)"
      >
        <img
          src="../../../static/images/index/apply.png"
          style="width: 16px; height: 17px; margin-right: 8px"
        />
        <div>查看活动</div>
      </div>
      <div
        class="operateRight"
        v-if="isTime == 2"
        style="background-color: #999"
      >
        <img
          src="../../../static/images/index/apply.png"
          style="width: 16px; height: 17px; margin-right: 8px"
        />
        <div>观展预约</div>
      </div> -->
    </div>
    <!-- 右侧按钮 -->
    <div class="rightBox">
      <div class="back" v-if="backTopShow" @click.stop="goTop">
        <img
          src="../../../static/images/icon/up.png"
          style="width: 25px; height: 25px"
        />
      </div>
    </div>

    <!-- 参展报名 -->
    <div v-if="joinModal" class="applyBox">
      <div class="applyTitle">参展报名</div>
      <div class="subTitle">
        <div>请前往电脑端进行报名,</div>
        <div>复制网址使用电脑浏览器打开即可</div>
      </div>
      <div class="applyBoxBtn">
        <div @click="cancelHandle">取消</div>
        <!-- <div style="color: #576b95" @click="cancelHandle">确定</div> -->
        <div
          style="color: #576b95"
          @click="
            copyHandle(
              'https://www.alighting.com/Views/activity_sign/index.html'
            )
          "
        >
          复制网址
        </div>
      </div>
    </div>
    <!-- 观展预约 -->
    <div v-if="seeModal" class="applyBox">
      <div style="font-size: 17px; padding: 40px 0px" v-if="isTime == 0">
        活动已成功预约
      </div>
      <div class="applyBoxBtn">
        <div style="color: #576b95" @click="knowHandle">我知道了</div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="joinModal || seeModal" @click="cancelHandle"></div>
  </div>
</template>
<script>
import { formatTimeDay } from "@/utils/date.js";
import { Swipe, SwipeItem, Image } from "vant";
import {
  getMediaPartnersList,
  getSEModel,
  getSEListOneYear,
  liveSpecialList,
} from "@/api/online";
export default {
  name: "activity",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-image": Image,
  },
  data() {
    return {
      seeModal: false,
      joinModal: false, //参展报名弹窗
      bigList: [],
      offsetTop: 700,
      backTopShow: false,
      Content:
        "绿色低碳照明、智能照明细分领域的相关照明设计及工业设计机构、独立设计师、工程设计单位、照明生产厂家等网上展厅会员。",
      // 轮播图参数
      interval: 3000,
      duration: 500,
      current: 0,
      scurrent: 0,
      bannerList: [
        {
          Img: "https://files.alighting.com/cover/annualActivities01.jpg",
          Title: "参展品牌在线展示",
          Cotent:
            "集中展示照明领域最新产品、技术及应用，以静态数字化展示+动态直播化演示为表现形式，链接企业的数字化品牌展厅，全方位展现品牌风采，企业可借助平台工具及数字化营销手段，线上拓客，挖掘商机。",
        },
        {
          Img: "https://files.alighting.com/cover/annualActivities02.jpg",
          Title: "照明设计、工程展示专区",
          Cotent:
            "特邀照明细分领域相关工程、设计单位共同参与，以不同维度、视角 解析诠释照明最新应用、技术，剖析其最新设计观点及理念，分享最新照明趋势。",
        },
        {
          Img: "https://files.alighting.com/cover/annualActivities03.jpg",
          Title: "品牌联展直播巡回",
          Cotent:
            "特邀照明领域精英或意见领袖，以直播连线或展会现场探馆直播的方式，通过实时在线直播讲解、分享的方式，为线上观众发现和挖掘照明领域最新产品应用及解决方案。",
        },
        {
          Img: "https://files.alighting.com/cover/annualActivities04.jpg",
          Title: "主题光影艺术空间",
          Cotent:
            "有主题性的聚合各照明细分领域最新产品及技术应用，线下打造光影艺术空间，沉浸式照明体验，从视觉、听觉、触觉多感官感受光的魅力。",
        },
        {
          Img: "https://files.alighting.com/cover/annualActivities05.jpg",
          Title: "多主题论坛/研讨会/沙龙",
          Cotent:
            "活动同期设置多场高质量、高水平线上主题论坛/研讨会/沙龙直播，并联合全国各地照明协会、学会、灯饰城等多方行业资源，多层次多角度解锁产业发展关键问题、解读市场动态，把脉行业发展动向。",
        },
        {
          Img: "https://files.alighting.com/cover/annualActivities06.jpg",
          Title: "照明行业数字化营销系列培训课程",
          Cotent:
            "该系列课程培训将邀请众多一线实战派营销专家及数字营销平台服务商参与，深度探讨照明企业数字 化营销的新思路、新模式、新渠道，探索数字化营销为照明企业实现降本增效、价值赋能的有效途径。",
        },
      ],
      list: [
        {
          Img: "https://files.alighting.com/cover/popularize01.png",
          Title: "阿拉丁网上照明展网站PC端 &小程序",
          subTitle: "背靠微信生态系统给网站引流",
        },
        {
          Img: "https://files.alighting.com/cover/popularize02.png",
          Title: "阿拉丁照明网—照明行业门户网站",
          subTitle: "提供照明行业前沿新闻",
        },
        {
          Img: "https://files.alighting.com/cover/popularize03.png",
          Title: "阿拉丁照明网微信号",
          subTitle: "照明行业信息传播及交流移动互动平台， 累计粉丝达12W+",
        },
        {
          Img: "https://files.alighting.com/cover/popularize04.png",
          Title: "阿拉丁设计杂志",
          subTitle: "泛照明行业工程跨界杂志",
        },
        {
          Img: "https://files.alighting.com/cover/popularize05.png",
          Title: "SNS海外标靶社媒渠道",
          subTitle:
            " Facebook、Twitter、LinkedIn、YouTube、Instagram，累计覆盖率达300W+",
        },
        {
          Img: "https://files.alighting.com/cover/popularize06.png",
          Title: "自媒体平台",
          subTitle: "今日头条、搜狐号、微信视频号、官方抖音等多个自媒体平台",
        },
        {
          Img: "https://files.alighting.com/cover/popularize07.png",
          Title: "微信朋友圈广告",
          subTitle: "灵活自由配置，提高商家曝光度。",
        },
        {
          Img: "https://files.alighting.com/cover/popularize08.png",
          Title: "数字化营销服务",
          subTitle:
            "EDM精准买家邮件&精准买家群发短信，标靶全球照明产业数据资源库",
        },
      ],
      sourceList: [
        "https://files.alighting.com/cover/gz1.jpg",
        "https://files.alighting.com/cover/gz2.jpg",
        "https://files.alighting.com/cover/gz3.jpg",
      ],
      mideaList: [],
      hisList: [],
      info: "",
      startTime: "",
      endTime: "",
      isTime: 0,
      exTitle: "",
    };
  },
  methods: {
    copyHandle() {
      var path =
        "https://www.alighting.com/views/activity_sign/index.html?sid=" +
        this.$route.query.id;
      //复制网址
      this.$copyText(path).then(
        (e) => {
          this.$toast.success("复制成功");
        },
        (e) => {
          this.$toast.fail("复制失败");
        }
      );
    },
    //判断滚动条位置
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > this.offsetTop) {
        this.backTopShow = true;
      } else {
        this.backTopShow = false;
      }
    },

    //返回顶部
    goTop() {
      window.scrollTo(0, 0);
    },

    // 改变轮播图
    bannerChange(e) {
      this.current = e;
    },

    //资源轮播图
    sourceChange(e) {
      this.scurrent = e;
    },

    //获取一年主题展
    getYear() {
      var that = this;
      getSEListOneYear().then((res) => {
        var that = this;
        var list = res.Data;
        list.forEach((item, index) => {
          item.listIn = [];
          item.listOut = [];
          item.SubjectExhibitionList.forEach((pitem, pindex) => {
            if (pitem.SubjectExhibition.AreaClass == 0) {
              item.listIn.push(pitem);
            } else {
              item.listOut.push(pitem);
            }
          });
          that.$set(that.bigList, index, item);
        });
      });
    },

    //获取详情
    getInfo() {
      var that = this;
      getSEModel({ ID: this.$route.query.id }).then((res) => {
        that.info = res.Data.SubjectExhibition;
        that.exTitle = res.Data.SubjectExhibition.SETitle;
        that.startTime = that.formatTimeDate(res.Data.SubjectExhibition.SETime);
        that.endTime = that.formatTimeDate(
          res.Data.SubjectExhibition.SETimeEnd
        );
        var date = new Date();
        var nowDate = formatTimeDay(date.toLocaleDateString());
        if (that.startTime > nowDate) {
          that.isTime = 0;
        } else if (nowDate > that.startTime && nowDate == that.endTime) {
          that.isTime = 1;
        } else if (that.endTime < nowDate) {
          that.isTime = 2;
        } else {
        }
      });
      that.getMediaList();
    },

    //格式化时间
    formatTimeDate(date) {
      var date = date
        .toString()
        .replace(/T/g, " ")
        .substring(0, 10)
        .replace(/-/g, "/");
      return date;
    },

    //获取合作媒体资源
    getMediaList() {
      var that = this;
      getMediaPartnersList({ ID: 308 }).then((res) => {
        that.mideaList = res.Data.List;
      });
    },

    //切换
    toTabDetail(id) {
      this.$router.replace({
        path: "/activity",
        query: { id: id },
      });
      this.getInfo();
    },

    //获取往期回顾
    getLiveSpecialList() {
      liveSpecialList({
        Page: {
          PageSize: 4,
          PageIndex: 1,
        },
        IsRec: 1,
        Keyword: "",
      }).then((res) => {
        this.hisList = res.Data.List;
      });
    },

    //跳转专题详情
    toSpecialDetail(id) {
      this.$router.push({ path: "/specificActDetail", query: { sid: id } });
    },

    //观展预约
    toSee() {
      this.seeModal = true;
      this.isTime = 0;
    },

    // 我知道了
    knowHandle() {
      this.seeModal = false;
    },

    //跳转
    toMidea(url) {
      if (url.indexOf("http") >= 0) {
        window.location.href = url;
      }
    },

    //申请参展
    toDetailHandle() {
      window.location.href =
        "https://www.alighting.cn/special/20200812/index.html";
    },

    //点击参展报名
    toJoin() {
      this.joinModal = true;
    },

    //点击取消
    cancelHandle() {
      this.joinModal = false;
    },
  },

  created() {
    this.getInfo();
  },
  mounted() {
    this.getYear();
    this.getLiveSpecialList();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped src="../../../static/css/activity.css">
</style>